export const freeContractOptions = [
  {label: "Freihopfen Schätzmenge", value: 1},
  {label: "Freihopfen Menge bekannt", value: 2},
  {label: "Freihopfen Überlieferung", value: 3},
]
